import { useEffect, useState, useContext, useRef } from 'react'
import Select from 'react-select'
import { Controller } from "react-hook-form";
import { LocationContext } from './SelectLocationGroup';

const SelectProvince = ({ control }) => {
    const [options, setOptions] = useState([])
    const locationOptions = useContext(LocationContext)

    const loadData = useRef(() => { })
    loadData.current = () => {
        if (locationOptions) {
            const pv = []
            locationOptions.map(i => {
                if (!pv.includes(i.province)) {
                    pv.push(i.province)
                }
                return i
            })
            if (pv.length > 0) {
                setOptions(pv.map(i => {
                    return {
                        label: i,
                        value: i
                    }
                }))
            }
        }
    }

    useEffect(() => {
        loadData.current()
    }, [locationOptions])

    return (<Controller
        name="province"
        control={control}
        rules={{ required: true }}
        render={({ field }) => <Select options={options}
            placeholder="เลือกจังหวัด"
            isClearable
            {...field} />}
    />)

}

export default SelectProvince